import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const styled = withStyles(theme => {
  return {
    container: {
      overflowX: 'auto'
    },
    table: {
      margin: '0px auto'
    },
    tableHead: {
      backgroundColor: '#fff',
    }
  };
});

class TabAuthProviders extends React.Component {
  renderRow(data) {

    return (
      <TableRow key={data.name + data.id}>
        <TableCell padding="dense">
          <Typography>{data.name}</Typography>
        </TableCell>
        <TableCell padding="dense">
          <Typography>{data.id}</Typography>
        </TableCell>
      </TableRow>
    );
  }

  render() {
    const { classes, data } = this.props;
    return (
      <div className={classes.container}>
        <Table className={classes.table}>
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell>Provider</TableCell>
              <TableCell>ID</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{data.providers.map(item => this.renderRow(item))}</TableBody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.userProfile.data
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {}
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(TabAuthProviders))
);
